import { createSlice  } from "@reduxjs/toolkit";

const initialStateValue=[];

const taskTime = (value) => {
    const parsed = Date.parse(value || '');
    return Number.isNaN(parsed) ? 0 : parsed;
}

const groupLatestTime = (taskGroup = {}) => {
    const groupTime = taskTime(taskGroup.sortKey || taskGroup.updated_at);
    const jobsTime = Array.isArray(taskGroup.jobs)
        ? Math.max(0, ...taskGroup.jobs.map((job) => taskTime(job.updated_at)))
        : 0;

    return Math.max(groupTime, jobsTime);
}

const sortJobsByLatestUpdate = (jobs = []) => [...jobs].sort((a, b) => (
    groupLatestTime({jobs:[b]}) - groupLatestTime({jobs:[a]}) ||
    (parseInt(b.id) || 0) - (parseInt(a.id) || 0)
))

const sortTaskGroupsByLatestUpdate = (taskGroups = []) => [...taskGroups].sort((a, b) => (
    groupLatestTime(b) - groupLatestTime(a) ||
    (parseInt(b.parentTaskId) || 0) - (parseInt(a.parentTaskId) || 0)
))

const normalizeTasks = (payload) => {
    let tasks = [];

    if(Array.isArray(payload)){
        tasks = payload;
    }else if(Array.isArray(payload?.tasks)){
        tasks = payload.tasks;
    }else if(Array.isArray(payload?.data)){
        tasks = payload.data;
    }else if(Array.isArray(payload?.tasks?.data)){
        tasks = payload.tasks.data;
    }else if(payload && typeof payload === 'object' && payload.referenceId && Array.isArray(payload.jobs)){
        tasks = [payload];
    }

    if(Array.isArray(payload?.pinned)){
        tasks = [...payload.pinned, ...tasks];
    }

    return tasks.reduce((mergedTasks, taskGroup) => {
        if(!taskGroup?.referenceId || !Array.isArray(taskGroup.jobs)){
            return mergedTasks;
        }

        const existingIndex = mergedTasks.findIndex((task) => task.referenceId === taskGroup.referenceId);
        if(existingIndex < 0){
            mergedTasks.push({
                ...taskGroup,
                jobs: sortJobsByLatestUpdate(taskGroup.jobs.filter((job, index, jobs) => jobs.findIndex((item) => item.id === job.id) === index)),
            });
            return mergedTasks;
        }

        const existingGroup = mergedTasks[existingIndex];
        const jobsById = new Map();
        [...existingGroup.jobs, ...taskGroup.jobs].forEach((job) => {
            const previousJob = jobsById.get(job.id);
            jobsById.set(job.id, {
                ...previousJob,
                ...job,
                isPinned: Boolean(previousJob?.isPinned ?? previousJob?.pinned ?? job?.isPinned ?? job?.pinned),
                pinned: Boolean(previousJob?.isPinned ?? previousJob?.pinned ?? job?.isPinned ?? job?.pinned),
            });
        });

        mergedTasks[existingIndex] = {
            ...existingGroup,
            ...taskGroup,
            customer: existingGroup.customer || taskGroup.customer,
            updated_at: taskGroup.updated_at || existingGroup.updated_at,
            sortKey: taskGroup.sortKey || existingGroup.sortKey,
            jobs: sortJobsByLatestUpdate(Array.from(jobsById.values())),
        };

        return mergedTasks;
    }, []).sort((a, b) => (
        groupLatestTime(b) - groupLatestTime(a) ||
        (parseInt(b.parentTaskId) || 0) - (parseInt(a.parentTaskId) || 0)
    ));
}

export const taskSlice=createSlice({
    name:'allTasks',
    initialState:{value:initialStateValue},
    reducers:{
        setTasks:(state, action)=>{
            state.value=normalizeTasks(action.payload)
        },
        appendTasks:(state, action)=>{
            state.value=normalizeTasks([...normalizeTasks(state.value), ...normalizeTasks(action.payload)])
        },
        addTask:(state,action)=>{
            const allTasks=normalizeTasks(state.value);
            const newTasks=normalizeTasks(action.payload);
            state.value=[...newTasks,...allTasks]
        },
        updateTaskCustomer:(state, action)=>{
            state.value=state.value.map((t)=>t.referenceId===action.payload.reference?
            {
            ...t,
            customer:action.payload.customer
            }:
            t)
        },
        updateTaskStatus:(state,action)=>{

            var updateJob=action.payload.task;
            var isMultiple=action.payload.multiple;
            var allTasks=state.value
            var tasklist=allTasks.filter((t)=>t.referenceId===action.payload.reference)[0]
            if(!tasklist){
                return;
            }
            var oldJobs=tasklist.jobs;

            if(isMultiple){
                const updateJobs=Array.isArray(updateJob) ? updateJob : [updateJob];
                const updateJobIds=updateJobs.map((job)=>job.id);
                tasklist.jobs=sortJobsByLatestUpdate([...updateJobs, ...oldJobs.filter((job)=>!updateJobIds.includes(job.id))]);
                tasklist.updated_at=tasklist.jobs[0]?.updated_at || tasklist.updated_at;
                tasklist.sortKey=tasklist.updated_at;
                state.value=sortTaskGroupsByLatestUpdate(allTasks.map((t)=>t.referenceId===action.payload.reference ? tasklist : t))
                return;
            }

            const previousJob=oldJobs.find(j=>j.id==updateJob.id);
            const hasUpdatedPinState=Object.prototype.hasOwnProperty.call(updateJob || {}, 'isPinned');
            if(previousJob && !hasUpdatedPinState){
                updateJob={
                    ...updateJob,
                    isPinned: previousJob.isPinned ?? previousJob.pinned,
                    pinned: previousJob.isPinned ?? previousJob.pinned,
                }
            }

            if(previousJob){
                var newJob=tasklist.jobs.map(j=>j.id==updateJob.id ? updateJob : j)
            }else{
                var newJob=[updateJob, ...oldJobs]
            }
          
            tasklist.jobs=sortJobsByLatestUpdate(newJob);
            tasklist.updated_at=updateJob.updated_at || tasklist.jobs[0]?.updated_at || tasklist.updated_at;
            tasklist.sortKey=tasklist.updated_at;

            state.value=sortTaskGroupsByLatestUpdate(allTasks.map((t)=>t.referenceId===action.payload.reference ? tasklist : t))

            // state.value=state.value.map((t)=>t.referenceId==action.payload.reference?
            //     {
            //     ...t,
            //     jobs:t.jobs.map(j=>j.id==action.payload.jobId?
            //         {
            //         ...j,
            //         jobStatus:action.payload.jobStatus
            //         }:
            //         j)
            //     }:t)
        },
        deleteTask:(state, action)=>{
            var taskId=action.payload.taskId;

            var allTasks=state.value
            var tasklist=allTasks.filter((t)=>t.referenceId===action.payload.reference)[0]
            if(!tasklist){
                return;
            }

            var oldJobs=tasklist.jobs;
            var newJob=oldJobs.filter(j=>j.id!=taskId)
            var updateTask=[]
            if(newJob.length>0){
                updateTask=allTasks.map((t)=>t.referenceId===action.payload.reference?{
                    ...t,
                    jobs:newJob
                }:t);
            }else{
                updateTask=allTasks.filter((t)=>t.referenceId!==action.payload.reference)
            }
   
            state.value=updateTask

        },

    }
})

export const {setTasks, appendTasks, updateTaskCustomer, updateTaskStatus, deleteTask, addTask}=taskSlice.actions
export default taskSlice.reducer;
